import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretToLeftIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 15,
	viewBox: "0 0 12 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.166992 13.6332C0.166992 13.9093 0.39085 14.1332 0.666992 14.1332C0.943135 14.1332 1.16699 13.9093 1.16699 13.6332L1.16699 0.966554C1.16699 0.690411 0.943135 0.466553 0.666992 0.466553C0.39085 0.466553 0.166992 0.690411 0.166992 0.966553L0.166992 13.6332ZM11.713 1.29367C11.8933 1.08452 11.8699 0.768801 11.6608 0.588498C11.4516 0.408195 11.1359 0.431583 10.9556 0.640737L5.50143 6.96765C5.33986 7.15507 5.33969 7.43249 5.50103 7.62011L10.9539 13.9614C11.134 14.1708 11.4497 14.1946 11.659 14.0145C11.8684 13.8345 11.8922 13.5188 11.7122 13.3094L6.53993 7.29452L11.713 1.29367Z",
		fill: "#212121"
	})
});
export default SvgCaretToLeftIcon;
